import { api } from './api';

export const personalCareApi = api.injectEndpoints({
    endpoints: (builder) => ({
        getAdlList: builder.query({
            query: (payload) => ({
                url: 'api/core/adl-iadl/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['AdlList']
        }),
        getPersonalcareList: builder.query({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'LIST'
                }
            }),
            providesTags: ['PersonalCareList']
        }),
        createPersonalCare: builder.mutation({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'CREATE'
                }
            }),
            invalidatesTags: ['PersonalCareList', 'PersonalCareDetail']
        }),
        updatePersonalCare: builder.mutation({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'UPDATE'
                }
            }),
            invalidatesTags: ['PersonalCareList', 'PersonalCareDetail']
        }),
        getPersonalcareDetail: builder.query({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DETAIL'
                }
            }),
            providesTags: ['PersonalCareDetail']
        }),
        deletePersonalCare: builder.mutation({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'DELETE'
                }
            }),
            invalidatesTags: ['PersonalCareList']
        }),
        personalCareSign: builder.mutation({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'sign'
                }
            }),
            invalidatesTags: (result, error, arg) => (result ? ['PersonalCareList', 'PersonalCareDetail', 'UnsignedReportsList'] : [])
        }),
        getPersonalCareHistory: builder.query({
            query: (payload) => ({
                url: '/api/personal-care/activity/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'list'
                }
            })
            // invalidatesTags: ['TreatmentHistory']
        }),
        unlockPersonalCare: builder.mutation({
            query: (payload) => ({
                url: 'api/personal-care/',
                method: 'POST',
                body: payload,
                headers: {
                    SUBTYPE: 'unlock'
                }
            }),
            invalidatesTags: ['PersonalCareList', 'PersonalCareDetail']
        })
    })
});

export const {
    useGetAdlListQuery,
    useGetPersonalcareListQuery,
    useCreatePersonalCareMutation,
    useUpdatePersonalCareMutation,
    useGetPersonalcareDetailQuery,
    useLazyGetPersonalcareDetailQuery,
    useDeletePersonalCareMutation,
    usePersonalCareSignMutation,
    useLazyGetPersonalCareHistoryQuery,
    useUnlockPersonalCareMutation
} = personalCareApi;
